"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReferer = getReferer;
function getReferer() {
  const referer = window.location.pathname;
  return referer.match(/^\/([a-z]{2})\//)?.[1] ? referer.slice(3) : referer;
}